module.exports = __webpack_public_path__ + "img/55e363d.png";